export default function ServicesSection() {
  return (
    <section id="services" className="px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Optimize AI Compute Performance
          </h2>
          <p className="mt-4 text-foreground-600">
            We offer a diverse range of Reserved GPUaaS services, focusing on
            high-performance compute and flexible configurations to ensure we
            meet our clients&apos; diverse needs.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              title: "Flexible Reserved GPUaaS",
              text: "Provide flexible and efficient compute resource allocation based on your project requirements.",
              img: "https://up.abstractdata.ai/uploads/2025/08/Chip01-300x225-1.jpg",
            },
            {
              title: "Professional GPU Acceleration",
              text: "Utilize top-tier GPU hardware to deliver high-speed computing for AI workloads.",
              img: "https://up.abstractdata.ai/uploads/2025/08/IDC01-300x225-1.jpg",
            },
            {
              title: "Secure and Reliable Data Processing",
              text: "Ensure data privacy and system stability, creating a trustworthy compute environment.",
              img: "https://up.abstractdata.ai/uploads/2025/08/Chip02-300x225-1.jpg",
            },
          ].map((s) => (
            <div
              key={s.title}
              className="flex flex-col rounded-lg bg-background-100 border border-background-200 overflow-hidden"
            >
              <div className="p-6 pb-0">
                <h3 className="font-heading font-semibold text-xl text-foreground-950 text-center">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 text-center">
                  {s.text}
                </p>
              </div>
              <div className="p-6 pt-4 flex justify-center">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full max-w-[300px] h-auto object-cover rounded-md"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}